import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'

import { Typeahead } from 'react-bootstrap-typeahead'
import { FormGroup, ControlLabel, Button, Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import { editUser } from '../../login/reducers/manageLogin'

class EditUserClients extends Component {
  state = {
    selectedUser: [],
    selectedClients: [],
  }

  _renderMenuItemChildren = (user, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
    return [
      <div key="name" search={props.text}>
        <strong>{user.first_name} {user.last_name}</strong>
      </div>,
      <div key="email">
        <small>
          Email: {user.email ? user.email : "N/A"}
        </small>
      </div>,
    ]
  }

  handleSelectUser = (selectedUser) => {
    if (!selectedUser || selectedUser.length === 0) {
      return
    }

    const { clients } = this.props

    let selectedClients = selectedUser[0].clients.map(clientUrl => {
      return clients.find(client => client.url === clientUrl) || null
    })

    selectedClients = selectedClients.filter(Boolean)

    this.setState({ selectedUser, selectedClients })
  }

  editUserClients = () => {
    const { selectedUser, selectedClients } = this.state

    if (selectedUser.length === 0) {
      return
    }

    const userUrl = selectedUser[0].url

    swal({
      text: "Saving user's clients...",
      icon: require("../../../static/images/spinner.gif"),
      button: false
    })

    axios({
      method:"PATCH",
      url: userUrl,
      headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      data: { clients: selectedClients.map(client => client.url), }
    })
    .then(response => {
      swal({
        title: "Success",
        text: "The user's clients have been updated",
        icon: "success",
        button: "Continue",
      })
      this.props.editUser(response.data)
    })
    .catch(error => {
      const message = "There was an error editing the user's clients"
      handleErrorFetchingData(error, message)
    })
  }

  render() {
    const { selectedUser,  selectedClients } = this.state
    const { users,  clients } = this.props

    const sortedUsers = users.filter(user => user.is_active).sort((a, b) => {
      const userA = `${a.first_name} ${a.last_name}`
      const userB = `${b.first_name} ${b.last_name}`
      return userA.localeCompare(userB)
    })

    const editUserClientsPopover = (
      <Popover id='edit-user-clients-popover' title="Edit User's Clients">
        <p>
          Associations between users and clients allows users to log in to that client's PTOR, if that client has their own PTOR.
        </p>
        <br/>
        <p>
          Genesis Research employees will need an association to <strong>Genesis Research RWE</strong> in order to log into <strong>genesis.ptor.io</strong>
        </p>
      </Popover>
    )

    return (
      <div id='EditUserClients'>
        <h4 style={{display: 'inline-block'}}>
          Edit a User's Clients
        </h4> &nbsp;
        <OverlayTrigger
          trigger={["hover", "focus"]}
          placement="right"
          overlay={editUserClientsPopover}
        >
          <Glyphicon glyph='info-sign' style={{display: 'inline-block'}} />
        </OverlayTrigger>

        <FormGroup>
          <ControlLabel>
            Select User
          </ControlLabel>
          <Typeahead
            id='SelectedUserTypeahead'
            labelKey={user => `${user.first_name} ${user.last_name}`}
            options={sortedUsers}
            selected={selectedUser}
            onChange={this.handleSelectUser}
            renderMenuItemChildren={this._renderMenuItemChildren}
          />
        </FormGroup>

        {this.state.selectedUser.length ?
          <FormGroup>
            <ControlLabel>
              Select Client(s)
            </ControlLabel>
            <Typeahead
              id='EditUserClientsTypeahead'
              multiple
              labelKey={client => `${client.name} ${client.short_code}`}
              options={clients}
              selected={selectedClients}
              onChange={(selectedClients) => this.setState({ selectedClients })}
              placeholder="Select clients"
            />
            <br/>
            <Button
              bsStyle="primary"
              onClick={this.editUserClients}
            >
              Save
            </Button>
          </FormGroup>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.manageLogin.users,
    clients: state.manageLogin.clients,
  }
}

export default connect(mapStateToProps, { editUser })(EditUserClients)



// WEBPACK FOOTER //
// ./src/routes/manager/components/EditUserClients.js